import { apiRequest } from '../axiosInstance';
import axiosInstance from '../axiosInstance';
import { SMS_TEMPLATE_ENDPOINTS, buildQueryString } from '../endpoints';

const smsTemplateService = {
  getTemplates: async () => {
    return apiRequest(() =>
      axiosInstance.get(SMS_TEMPLATE_ENDPOINTS.LIST)
    );
  },

  getTemplateById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(SMS_TEMPLATE_ENDPOINTS.GET_BY_ID(id))
    );
  },

  updateTemplate: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(SMS_TEMPLATE_ENDPOINTS.UPDATE(id), data)
    );
  },

  getLogs: async (params = {}) => {
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${SMS_TEMPLATE_ENDPOINTS.LOGS}${queryString}`)
    );
  },

  sendTestSms: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.post(SMS_TEMPLATE_ENDPOINTS.SEND_TEST(id), data)
    );
  },

  getConfig: async () => {
    return apiRequest(() =>
      axiosInstance.get(SMS_TEMPLATE_ENDPOINTS.CONFIG)
    );
  },

  createOrgOverride: async (systemTemplateId) => {
    return apiRequest(() =>
      axiosInstance.post(SMS_TEMPLATE_ENDPOINTS.ORG_OVERRIDE(systemTemplateId))
    );
  },

  deleteOrgOverride: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(SMS_TEMPLATE_ENDPOINTS.DELETE_ORG_OVERRIDE(id))
    );
  },

  generateAiTemplate: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(SMS_TEMPLATE_ENDPOINTS.GENERATE_AI, data, { timeout: 300000 })
    );
  },

  getVariableInfo: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(SMS_TEMPLATE_ENDPOINTS.VARIABLE_INFO(id))
    );
  },
};

export default smsTemplateService;
